module.exports = __webpack_public_path__ + "static/media/record_again.fd91ad47.png";